import type * as lazyIndex from "./lazyIndex";
import type { PreviewConditionalFormattingMailListItemProps } from "./components/PreviewConditionalFormattingMailListItem";
import { LazyAction, LazyModule, createLazyComponent, type LazyComponent } from "owa-bundling";

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "OwaMailListItemLazy"*/ "./lazyIndex"), { name: "OwaMailListItemLazy" });

export const lazyRegisterConditionalFormattingPreview: LazyAction<typeof lazyIndex.registerConditionalFormattingPreview, typeof lazyModule> = new LazyAction(lazyModule, m => m.registerConditionalFormattingPreview);

export const PreviewConditionalFormattingMailListItem: LazyComponent<PreviewConditionalFormattingMailListItemProps, unknown, void> = createLazyComponent(lazyModule, m => m.PreviewConditionalFormattingMailListItem);
